<template>
  <!-- Left div because b-navbar does not trigger on mouseenter / mouseleave events -->
  <div class="sidenav navbar navbar-vertical fixed-left navbar-expand-xs navbar-light bg-white"
       @mouseenter="$sidebar.onMouseEnter(); sidebarState(true);"
       @mouseleave="$sidebar.onMouseLeave(); sidebarState(false);"
       :data="backgroundColor">
    <div class="scrollbar-inner" ref="sidebarScrollArea">
      <div class="sidenav-header d-flex align-items-center">
        <b-navbar-brand href="#"  @click="$sidebar.displaySidebar(!$sidebar.showSidebar)">
          <img :src="logo" class="navbar-brand-img" alt="Sidebar logo">
        </b-navbar-brand>
        <div class="ml-auto">
          <!-- Sidenav toggler -->
          <div class="sidenav-toggler d-none d-xl-block"
               :class="{'active': !$sidebar.isMinimized }"
               @click="minimizeSidebar">
            <div class="sidenav-toggler-inner">
              <i class="sidenav-toggler-line"></i>
              <i class="sidenav-toggler-line"></i>
              <i class="sidenav-toggler-line"></i>
            </div>
          </div>
        </div>
      </div>
      <slot></slot>
      <div class="navbar-inner">
        <b-navbar-nav>
          <slot name="links">
            <sidebar-item
              v-for="(link, index) in sidebarLinks"
              :key="link.name + index"
              :link="link"
            >
              <sidebar-item
                v-for="(subLink, index) in link.children"
                :key="subLink.name + index"
                :link="subLink"
              >
              </sidebar-item>
            </sidebar-item>
          </slot>
        </b-navbar-nav>
        <slot name="links-after"></slot>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'sidebarView',
  props: {
    title: {
      type: String,
      default: 'Creative Tim',
      description: 'Sidebar title'
    },
    shortTitle: {
      type: String,
      default: 'CT',
      description: 'Sidebar short title'
    },
    logo: {
      type: String,
      default: 'img/brand/green.png',
      description: 'Sidebar app logo'
    },
    backgroundColor: {
      type: String,
      default: 'vue',
      validator: value => {
        let acceptedValues = [
          '',
          'vue',
          'blue',
          'green',
          'orange',
          'red',
          'primary'
        ];
        return acceptedValues.indexOf(value) !== -1;
      },
      description:
        'Sidebar background color (vue|blue|green|orange|red|primary)'
    },
    sidebarLinks: {
      type: Array,
      default: () => [],
      description:
        "List of sidebar links as an array if you don't want to use components for these."
    },
    autoClose: {
      type: Boolean,
      default: true,
      description:
        'Whether sidebar should autoclose on mobile when clicking an item'
    }
  },
  provide() {
    return {
      autoClose: this.autoClose
    };
  },
  methods: {
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize();
        localStorage.setItem('sidebar-minimized', this.$sidebar.isMinimized);
      }
    },
    sidebarState(mouseEntered) {
      if (mouseEntered) {
        this.$emit('sidebar-minimized', false);
      } else {
        this.$emit('sidebar-minimized', this.$sidebar.isMinimized);
      }
      
    }
  },
  mounted() {
    const savedState = localStorage.getItem('sidebar-minimized');
    const shouldBeMinimized = savedState === 'true';

    const body = document.body;
    const classList = body.classList;

    if (shouldBeMinimized) {
      // Remove all possible conflicting sidebar classes
      classList.remove('g-sidenav-pinned', 'g-sidenav-show', 'g-sidenav-hide');
      classList.add('g-sidenav-hidden');
      this.$sidebar.isMinimized = true;
    } else {
      this.$sidebar.isMinimized = this.$sidebar.breakpoint < window.innerWidth
      this.minimizeSidebar()
    }

    this.sidebarState(false)
  },
  beforeDestroy() {
    if (this.$sidebar.showSidebar) {
      this.$sidebar.showSidebar = false;
    }
  }
};
</script>
